import React from 'react';
import PropertyValue from './PropertyValue';
import reactCSS, { hover } from 'reactcss';
import { ChromePicker } from 'react-color'
import Color from 'color';

class ColorValue extends PropertyValue {

  constructor(props) {
    super(props);

    this.value = this.props.getValue() || 'white';

    const defaultColor = Color(this.value);

    this.state = {
      displayColorPicker: false,
      color: Object.assign(defaultColor.object(), {a: defaultColor.valpha})
    };
  }

  handleClick = (e) => {
    this.mouseX = e.clientX;
    this.mouseY = e.clientY;
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false })
  };

  handleChange = (color) => {
    this.setState({ color: color.rgb })
    this.value = Color({r: color.rgb.r, g: color.rgb.g, b: color.rgb.b}).alpha(color.rgb.a).string();
    if(this.props.onChange)
      this.props.onChange(this.value);
  };

  render() {
    const styles = reactCSS({
      'default': {
        color: {
          width: '16px',
          height: '16px',
          background: `rgba(${ this.state.color.r }, ${ this.state.color.g }, ${ this.state.color.b }, ${ this.state.color.a })`,
          border: "1px solid #252A33"
        },
        popover: {
          top: this.mouseY,
          left: this.mouseX,
          position: 'fixed',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
      'hover': {
        color: {
          cursor: 'pointer'
        },
      },
    }, this.props);

    return (
      <div>
        <div onClick={ this.handleClick }>
          <div style={ styles.color } />
        </div>
        { this.state.displayColorPicker ? <div style={ styles.popover }>
          <div style={ styles.cover } onClick={ this.handleClose }/>
          <ChromePicker color={ this.state.color } onChange={ this.handleChange } />
        </div> : null }

      </div>
    )
  }

}

export default hover(ColorValue)



// WEBPACK FOOTER //
// ./src/components/ui/ColorValue.js